import { ScrollBehavior } from 'data-types-config';
import type { AnchorPatternProps } from './AnchorPattern.types';

export const placeholderAnchorPattern: AnchorPatternProps = {
  text: 'Scroll to Section',
  href: '#section1',
  scrollBehavior: ScrollBehavior.Smooth,
};

export const placeholderAnchorPatternList: AnchorPatternProps[] = [
  {
    text: 'Top of Page',
    href: '#top',
    scrollBehavior: ScrollBehavior.Auto,
  },
  {
    text: 'Features',
    href: '#features',
    scrollBehavior: ScrollBehavior.Smooth,
  },
];
